/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BillingV1SubscriptionsDestroyPathParameters,
  BillingV1SubscriptionsListParams,
  BillingV1SubscriptionsPartialUpdatePathParameters,
  CursorPaginatedSubscriptionResponseV1,
  PatchedSubscriptionUpdateRequestV1Request,
  SubscriptionCreateRequestV1Request,
  SubscriptionResponseV1
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BillingSubscriptionService {
  private readonly http = inject(HttpClient);
/**
 * Admin-only. Returns Subscription rows ordered by `id`. `?user_id=X` narrows to one user's contracts (history + active), and `?status=` to the ones that stand there today in Chile (M-bill-33).
 * @summary List subscriptions (cursor-paginated).
 */
 billingV1SubscriptionsList<TData = CursorPaginatedSubscriptionResponseV1>(params?: BillingV1SubscriptionsListParams, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionsList<TData = CursorPaginatedSubscriptionResponseV1>(params?: BillingV1SubscriptionsListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionsList<TData = CursorPaginatedSubscriptionResponseV1>(params?: BillingV1SubscriptionsListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionsList<TData = CursorPaginatedSubscriptionResponseV1>(
    params?: BillingV1SubscriptionsListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v1/billing/subscriptions/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v1/billing/subscriptions/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/v1/billing/subscriptions/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Admin-only. Creates a Subscription for the given `user_id`. Refused with 409 `/problems/subscription-overlap` if the user already has a contract whose window overlaps the requested `[active_from, active_to]`, and with 422 `/problems/subscription-active-to-before-active-from` if `active_to` is before `active_from` (the same day is a one-day contract). Omit `active_to` to leave the contract currently active. `grace_months` (0 to 12, default 0) are the free months from `active_from` (M-bill-20).
 * @summary Create a subscription (client contract).
 */
 billingV1SubscriptionsCreate<TData = SubscriptionResponseV1>(subscriptionCreateRequestV1Request: SubscriptionCreateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionsCreate<TData = SubscriptionResponseV1>(subscriptionCreateRequestV1Request: SubscriptionCreateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionsCreate<TData = SubscriptionResponseV1>(subscriptionCreateRequestV1Request: SubscriptionCreateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionsCreate<TData = SubscriptionResponseV1>(
    subscriptionCreateRequestV1Request: SubscriptionCreateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/v1/billing/subscriptions/`,
      subscriptionCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/v1/billing/subscriptions/`,
      subscriptionCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/v1/billing/subscriptions/`,
      subscriptionCreateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Editable fields: `cadence`, `active_to`, `system_fee_uf` (M-bill-1h), `grace_months` (M-bill-20). `user` is immutable (sending it is a 400). Omitted fields keep their stored value. A new `active_to` that would overlap another contract of the same user is refused with 409 `/problems/subscription-overlap`, and one before the stored `active_from` with 422 `/problems/subscription-active-to-before-active-from`. Editing `system_fee_uf` snapshots the new value on the NEXT trigger emission — past SubscriptionCharge rows keep their own snapshot. `grace_months` never goes down, and only extends before the first billed charge (M-bill-20).
 * @summary Partial-update a subscription (preserve-on-omit).
 */
 billingV1SubscriptionsPartialUpdate<TData = SubscriptionResponseV1>(pathParams: BillingV1SubscriptionsPartialUpdatePathParameters,
    patchedSubscriptionUpdateRequestV1Request?: PatchedSubscriptionUpdateRequestV1Request, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionsPartialUpdate<TData = SubscriptionResponseV1>(pathParams: BillingV1SubscriptionsPartialUpdatePathParameters,
    patchedSubscriptionUpdateRequestV1Request?: PatchedSubscriptionUpdateRequestV1Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionsPartialUpdate<TData = SubscriptionResponseV1>(pathParams: BillingV1SubscriptionsPartialUpdatePathParameters,
    patchedSubscriptionUpdateRequestV1Request?: PatchedSubscriptionUpdateRequestV1Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionsPartialUpdate<TData = SubscriptionResponseV1>(
    { identity }: BillingV1SubscriptionsPartialUpdatePathParameters,
    patchedSubscriptionUpdateRequestV1Request?: PatchedSubscriptionUpdateRequestV1Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v1/billing/subscriptions/${identity}/`,
      patchedSubscriptionUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v1/billing/subscriptions/${identity}/`,
      patchedSubscriptionUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v1/billing/subscriptions/${identity}/`,
      patchedSubscriptionUpdateRequestV1Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Admin-only. Refused with 409 `/problems/subscription-in-use` if any SubscriptionCharge references the contract — close via `PATCH active_to=<date>` instead. Succeeds with 204 (no body) when the Subscription has zero charges.
 * @summary Hard-delete a subscription.
 */
 billingV1SubscriptionsDestroy<TData = void>(pathParams: BillingV1SubscriptionsDestroyPathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 billingV1SubscriptionsDestroy<TData = void>(pathParams: BillingV1SubscriptionsDestroyPathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 billingV1SubscriptionsDestroy<TData = void>(pathParams: BillingV1SubscriptionsDestroyPathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  billingV1SubscriptionsDestroy<TData = void>(
    { identity }: BillingV1SubscriptionsDestroyPathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/v1/billing/subscriptions/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/v1/billing/subscriptions/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/v1/billing/subscriptions/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type BillingV1SubscriptionsListClientResult = NonNullable<CursorPaginatedSubscriptionResponseV1>
export type BillingV1SubscriptionsCreateClientResult = NonNullable<SubscriptionResponseV1>
export type BillingV1SubscriptionsPartialUpdateClientResult = NonNullable<SubscriptionResponseV1>
export type BillingV1SubscriptionsDestroyClientResult = NonNullable<void>
